import React, { useEffect, useState } from "react";

export default function TeamLogo({ club, size = 36, className = "" }) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  // Reset error state when club changes — keeps cycling logos from getting
  // permanently stuck after one missing file during a spin.
  useEffect(() => {
    setErrored(false);
  }, [club]);

  const showImage = !!club && !errored;

  return (
    <div
      style={{ width: size, height: size }}
      className={`shrink-0 rounded-md relative overflow-hidden transition-colors
        ${showImage && !loaded ? "bg-zinc-800/40" : ""}
        ${className}`}
    >
      {showImage && (
        <img
          src={`${process.env.PUBLIC_URL}/team-logos/${encodeURIComponent(club)}.png`}
          alt={club}
          onLoad={() => setLoaded(true)}
          onError={() => setErrored(true)}
          className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-200
            ${loaded ? "opacity-100" : "opacity-0"}`}
        />
      )}
    </div>
  );
}
